import React from "react";
import * as Icon from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import modules from '../utils/modules.json';


const Dashboard = () => {

  const navigate = useNavigate();

  const gotoLogin = (item) => {
    navigate(item.link, 
      {state: {
        title: item.title,
        module: item.module,
        color: item.color,
        description: item.description,
        gradient:item.gradient,
        redirect:item.redirect
        }
      });
  };

//   const dashboardItems = [
//     {
//       title: "MIS System",
//       icon: <Icon.BarChartFill size={34} />,
//       color: "primary",
//       description: "Production, Sales, Profit-Loss, National Exchequer and Projection Analysis",
//       link: '/login',
//       redirect:'/home',
//       module:'MIS',
//       gradient:'#0d6efd, #0dcaf0',
//     },

//     {
//       title: "HRIS",
//       icon: <Icon.PeopleFill size={34} />,
//       color: "success",
//       description:"Attendance, Leave, Transfer, Promotion, Disciplinary Action, DOCR",
//       link: '/login',
//       redirect:'/hris',
//       module:'HRIS',
//       gradient:'#098838, #77f7b2',
//     },

//     {
//       title: "Medical System",
//       icon: <Icon.HeartPulseFill size={34} />,
//       color: "danger",
//       description:"Medical Inventory, Prescription Generation, Patient History Analysis",
//       link: '/login',
//       redirect:'/medical',
//       module:'MEDICAL',
//       gradient:'#d20e0e, #f38259',
//     },

//     {
//       title: "IT Equipment Register",
//       icon: <Icon.PcDisplayHorizontal size={34} />,
//       color: "warning",
//       description: "Desktop/Laptop Computer, Printer, UPS History",
//       link: '/login',
//       redirect:'/ict',
//       module:'ICT',
//       gradient:'#d4ac0d, #e3d619',
//     },
//     {
//       title: "TYPE Test",
//       icon: <Icon.KeyboardFill size={34} />,
//       color: "info",
//       description:"Typing Speed, Accuracy & Keyboard Skill Test",
//       link: "/typeTest",
//       gradient:'#d20e0e, #f38259',
// }
//   ];

  return (
    <div
      className="container-fluid py-5" style={{ minHeight: "100vh", 
        background:"linear-gradient(to right,rgb(241, 245, 249),rgb(226, 232, 240))",
      }}
    >
      <div className="container">

          {/* Header */}

        <div className="text-center mb-5">
          <div className="d-inline-block px-4 py-2 rounded-pill shadow-sm mb-3"
            style={{ background: "#ffffff", color: "#0d6efd", fontWeight: "600", }}>
            <h4>BSEC Internal Services Portal</h4>
          </div>

          <h1 className="fw-bold display-5 text-dark">
            Organization Dashboard
          </h1>
          <hr></hr>
      </div>

        {/* Cards */}

        <div className="row g-4">

          {Object.entries(modules).map(([moduleName, module], index) => {

          const ModuleIcon = Icon[module.icon];

          return (
            <div className="col-xl-3 col-lg-4 col-md-6" key={index}>
              <div
                className="card border-0 shadow-sm h-100 overflow-hidden"
                style={{
                  borderRadius: "20px",
                  transition: "0.35s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.08)";
                }}
              >
                <div
                  className={`bg-${module.color}`}
                  style={{ height: "8px" }}
                ></div>

                <div className="card-body text-center p-4 d-flex flex-column">

                  <div
                    className={`bg-${module.color} text-white rounded-circle d-flex align-items-center justify-content-center mx-auto shadow`}
                    style={{ width: "75px", height: "75px" }}
                  >
                    {ModuleIcon && <ModuleIcon size={35} />}
                  </div>

                  <h4 className="fw-bold mt-4 mb-3">
                    {moduleName}
                  </h4>

                  <p
                    className="text-muted small flex-grow-1"
                    style={{ lineHeight: "1.7" }}
                  >
                    {module.description}
                  </p>

                  <button
                    className={`btn btn-${module.color} rounded-pill px-4 py-2 fw-semibold mt-3`}
                    onClick={() => gotoLogin(module)}
                  >
                    Open System
                  </button>

                </div>
              </div>
            </div>
          );
          })}
        </div>

        {/* Footer */}

        <div className="text-center mt-5 py-3 rounded-4 shadow-sm"
          style={{ background: "#ffffff", fontWeight: "500", color: "#495057",}}
        >
          © 2026 Design & Development by MIS & ICT, BSEC
        </div>

      </div>
    </div>
  );
};

export default Dashboard;